import tagit from '../libs/tag-it.min.js';
import colorbox from '../libs/jquery.colorbox-min.js';
import cycle from '../libs/jquery.cycle.all.js'

import './js/base.js'
import './js/search.js'
import './js/cookie.js'
import './js/menu.js'
import './js/tags.js'
import './js/filter.js'
import './js/internal.js'
import './js/home.js'
import './js/slide.js'
import './js/contato.js'
import './js/backtotop.js'

import './js/map.js'
import './js/locations.js'
import './scss/style.scss'

var share_text = jQuery('.internal .share').text();
jQuery('.addtoany_header').text(share_text);
